/**
 * Single source of truth for the SIPX Group brand mark.
 *
 *   <BrandMark size={28} />            — square logo tile
 *   <BrandMark size={28} rounded="md"/>— custom corner radius
 *
 * The asset itself is a black-background PNG with white wordmark, so it
 * naturally renders well on light AND dark UI without recoloring.
 */
export function BrandMark({ size = 28, rounded = "lg", className = "" }) {
  const radius = {
    sm: "rounded-sm",
    md: "rounded-md",
    lg: "rounded-lg",
    xl: "rounded-xl",
    "2xl": "rounded-2xl",
    full: "rounded-full",
  }[rounded] || "rounded-lg";
  return (
    <span
      aria-hidden
      className={`inline-grid shrink-0 place-items-center overflow-hidden bg-black ${radius} ${className}`}
      style={{ width: size, height: size }}
    >
      <img
        src="/brand/sipx-logo-192.png"
        alt=""
        width={size}
        height={size}
        className="h-full w-full object-contain"
        draggable={false}
      />
    </span>
  );
}

export default BrandMark;
